




import Vue from "vue";
import { Component, Provide } from "vue-property-decorator";

@Component({})
export default class SetupBase extends Vue {}
